import { alpha } from "@mui/material";
import { all } from "axios";
import { Employee, EmployeeType, RoleType } from "winslow-core";

export type ShortSettings = {
    maxCharsOn: boolean;
    maxChars: number
}

export const SHORT_SETTINGS : ShortSettings = {
    maxCharsOn: false,
    maxChars: 0
};

export type LongSettings = {
    maxCharsOn: boolean;
    maxChars: number
}

export const LONG_SETTINGS : LongSettings = {
    maxCharsOn: false,
    maxChars: 0
};

export type EmailSettings = {
    // email: string
    // requireBusinessOn: boolean,
}

export const EMAIL_SETTINGS : EmailSettings = {
    // email: "", 
    // requireBusinessOn: false,
};

export type EmployeeRecordSettings = {
    // id: string
}

export const EMPLOYEE_SETTINGS : EmployeeRecordSettings = {
    // id: "", 
};

export type PTOPoliciesSettings = {
    allowMultiple: boolean;
}

export const PTO_POLICIES_SETTINGS : PTOPoliciesSettings = {
    allowMultiple: true,
}

// export type WebsiteSettings = {
//     URL: string
// }

// export const WEBSITE_SETTINGS : WebsiteSettings = {
//     URL: "",
// };

export type CheckboxSingleSettings = {
    checked: boolean;
    choice: string
}

export const CHECKBOX_SINGLE_SETTINGS : CheckboxSingleSettings = {
    checked: false,
    choice: "",
};

export type CheckboxMultipleSettings = {
    default: string[];
    // allowNone: boolean;
    alphabetize: boolean;
    choices: string[]
}

export const CHECKBOX_MULTIPLE_SETTINGS : CheckboxMultipleSettings = {
    default: [],
    // allowNone: false,
    alphabetize: false,
    choices: [],
};

export type DropdownSettings = {
    default: string;
    alphabetize: boolean;
    editable: boolean;
    // allowNone: boolean;
    choices: string[];
}

export const DROPDOWN_SETTINGS = {
    default: "",
    alphabetize: false,
    editable: false,
    // allowNone: false,
    choices: [],
};

export type RadioSettings = {
    default: string;
    alphabetize: boolean;
    choices: string[];
}

export const RADIO_SETTINGS = {
    default: "",
    alphabetize: false,
    choices: [],
};

export type DateSettings = {
}

export const DATE_SETTINGS : DateSettings = {
};

export type FileSettings = {
    allowMultiple: boolean,
}

export const FILE_SETTINGS : FileSettings = {
    allowMultiple: false,
};

export type NumberSettings = {
    minNumOn: boolean,
    minNum: number,
    maxNumOn: boolean,
    maxNum: number,
}

export const NUMBER_SETTINGS : NumberSettings = {
    minNumOn: false,
    minNum: 0,
    maxNumOn: false,
    maxNum: 0,
};

export type PhoneSettings = {
}

export const PHONE_SETTINGS : PhoneSettings = {
};

export type RichSettings = {
}

export const RICH_SETTINGS : RichSettings = {
};  

export const SETTINGS_DEFAULT = {
    SHORT: SHORT_SETTINGS,
    LONG: LONG_SETTINGS,
    // EMAIL_SETTINGS: EMAIL_SETTINGS,
    // WEBSITE_SETTINGS: WEBSITE_SETTINGS,
    CHECKBOX_SINGLE: CHECKBOX_SINGLE_SETTINGS,
    CHECKBOX_MULTIPLE: CHECKBOX_MULTIPLE_SETTINGS,
    DROPDOWN: DROPDOWN_SETTINGS,
    RADIO: RADIO_SETTINGS,
    EMAIL: EMAIL_SETTINGS,
    EMPLOYEE_RECORD: EMPLOYEE_SETTINGS,
    PTO_POLICIES: PTO_POLICIES_SETTINGS,
    DATE: DATE_SETTINGS,
    FILE: FILE_SETTINGS,
    NUMBER: NUMBER_SETTINGS,
    PHONE: PHONE_SETTINGS,
    RICH: RICH_SETTINGS,
}

export const SETTINGS_DISPLAY = {
    SHORT: "Short",
    LONG: "Long",
    // EMAIL_SETTINGS: EMAIL_SETTINGS,
    // WEBSITE_SETTINGS: WEBSITE_SETTINGS,
    CHECKBOX_SINGLE: "Single checkbox",
    CHECKBOX_MULTIPLE: "Multiple checkboxes",
    DROPDOWN: "Dropdown",
    EMAIL: "Email",
    EMPLOYEE_RECORD: "Employee record",
    PTO_POLICIES: "PTO policies",
    RADIO: "Radio button",
    DATE: "Date",
    FILE: "File upload",
    NUMBER: "Number",
    PHONE: "Phone",
    RICH: "Rich text",
}

export const ROLE_DISPLAY = {
    [RoleType.ADMIN]: "Admin",
    [RoleType.MANAGER]: "Manager",
    [RoleType.EMPLOYEE]: "Employee",
}

export const EMPLOYEE_TYPE_DISPLAY = {
    [EmployeeType.US_FULL_TIME]: "US Full time",
    [EmployeeType.US_PART_TIME]: "US Part time",
    [EmployeeType.US_CONTRACTOR]: "US Contractor",
    [EmployeeType.US_VENDOR]: "US Vendor",
    [EmployeeType.INT_FULL_TIME]: "International Full time",
    [EmployeeType.INT_CONTRACTOR]: "International Contractor",
}
